<template>
  <div class="Lib">
    <div class="PageZg">{{ title }}</div>

    <CardsSwitcher :show="show" @switchTo="switchTo"></CardsSwitcher>

    <CardPreviews :cards="cards(show)"></CardPreviews>

    <div class="Fraza" v-if="showFraza">Вместе каждый может больше!</div>
  </div>
</template>

<script>
import CardsSwitcher from "@/components/CardsSwitcher.vue";
import CardPreviews from "@/components/CardPreviews.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    CardsSwitcher, CardPreviews
  },
  props: {
    title: String,
    userId: Number,
    showFraza: { type: Boolean, default: function() { return true; } },
  },
  data() {
    return {
      show: 'visible',
    }
  },
  methods: {
    switchTo(newType) {
      this.show = newType;
      this.$store.dispatch('loadCardsByUser', {userId: this.userId, type: this.show});
    },
    cards(show) {
      return this.$store.getters.cardsByUser(this.userId, this.show);
    },
  },
};
</script>
